import React from "react";
import {Link} from "react-router-dom";
import ArrowLeftIcon from "../ArrowLeftIcon";
import {useLanguage} from "../../hooks/LanguageContext";

const NavLinks = ({ links, activeLink, handleLinkClick }) => {
	const { language } = useLanguage();
	const rotateClass = language === "en" ? "rotate-180" : "";

	return (
		<ul className="md:flex hidden p-0 m-0 list-none gap-x-4 lg:gap-x-6">
			{links.map((link, index) => (
				<li key={index} className="flex items-end justify-center gap-1">
					{activeLink === link.href && (
						<ArrowLeftIcon
							className={`inline-block ${rotateClass} transition-transform duration-200`}
						/>
					)}
					<Link
						to={link.href}
						onClick={() => handleLinkClick(link.href)}
						className={`text-base font-medium  ${
							activeLink === link.href
								? "text-primary-700"
								: "text-gray-600 hover:text-primary-700"
						}`}
					>
						{link.text}
					</Link>
				</li>
			))}
		</ul>
	);
};

export default NavLinks;
